import { ReactElement, ReactNode } from 'react';
import { styled } from 'styled-components';
import layoutStyle from '../../../../components/styles/Layout';

const Layout = styled.div`
  ${layoutStyle}
  padding: 24px;
  display: grid;
  grid-template-rows: 48px auto 48px;
  gap: 24px;
`;

interface Props {
  header: ReactNode;
  body: ReactNode;
  footer: ReactNode;
}

const ContentLayout = ({ header, body, footer }: Props): ReactElement => (
  <Layout>
    {header}
    {body}
    {footer}
  </Layout>
);

export default ContentLayout;
